import React from 'react';
import PropTypes from 'prop-types';
import { withFormsy } from 'formsy-react';
import MaskedInput from 'react-text-mask';
import cx from 'classnames';
import helpers from '../../resources/helpers';
import telephoneCountryList from '../../resources/telephone-country-list';

import FormElementWrapper from '../core/FormElementWrapper';

import './TelephoneInput.scss';

class TelephoneInput extends React.Component {
	constructor(props) {
		super(props);

		const currentCountry = telephoneCountryList.filter((entry) => entry.iso2 === 'US')[0];

		this.state = {
			hasFocus: false,
			touched: false,
			hasValue: (props.value || '') !== '',
			value: props.value,
			countryChoicesVisible: true,
			currentCountry,
		};

		this.inputRef = React.createRef();
		this.handleLabelClick = this.handleLabelClick.bind(this);
		this.handleFocus = this.handleFocus.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
		this.handleValueChange = this.handleValueChange.bind(this);
		this.showDropDown = this.showDropDown.bind(this);
		this.handleCountryChange = this.handleCountryChange.bind(this);
	}

	componentWillReceiveProps(props) {
		const value = props.value;
		this.setState({
			hasValue: (value || '') !== '',
			value,
		});
	}

	async componentDidMount() {
		const visitorCountryCode = await helpers.getVisitorCountryCode();
		const visitorCountry = telephoneCountryList.filter((entry) => entry.iso2 === visitorCountryCode)[0];
		if (visitorCountry) {
			this.setState({
				currentCountry: visitorCountry,
			});
		}

		if (this.props.getInputElement) {
			this.props.getInputElement(this.inputRef.current);
		}
	}

	// Event Handlers
	handleLabelClick() {
		this.inputRef.current.inputElement.focus();
	}

	handleFocus() {
		if (this.props.onFocus) {
			this.props.onFocus();
		}
		this.setState({
			hasFocus: true,
			touched: true,
		});
	}

	handleBlur() {
		if (this.props.onBlur) {
			this.props.onBlur();
		}
		this.setState({
			hasFocus: false,
		});
	}

	handleValueChange(evt) {
		const value = evt.currentTarget.value;
		this.props.setValue(value);
		if (this.props.onChange) {
			this.props.onChange(value, this.state.touched);
		}
		this.setState({
			value,
			hasValue: value !== '',
		});
	}

	showDropDown() {
		this.setState({ countryChoicesVisible: !this.state.countryChoicesVisible });
	}

	handleCountryChange(country) {
		this.setState({ currentCountry: country });
	}

	render() {
		const props = this.props;
		const type = props.type || 'text';

		const { showError, errorMessage } = helpers.shouldComponentShowError({
			showError: this.props.showError,
			formHasHadAnInValidSubmit: this.props.formHasHadAnInValidSubmit,
			required: this.props.required,
			getErrorMessage: () => props.errorMessage,
			errorMessage: props.errorMessage,
			currentValue: this.state.hasValue,
		});

		return (
			<FormElementWrapper
				label={props.label}
				hideLabel={props.hideLabel}
				tooltip={props.tooltip}
				optionalLabel={props.optionalLabel}
				name={props.name}
				required={props.required}
				hasFocus={this.state.hasFocus}
				hasValue={this.state.hasValue}
				showError={showError}
				errorMessage={errorMessage}
				onLabelClick={this.handleLabelClick}>
				<div className="telephone-input">
					<MaskedInput
						ref={this.inputRef}
						mask={this.state.currentCountry.mask}
						guide={true}
						className={cx('basic-input__input', { 'basic-input__has-error': showError })}
						onFocus={this.handleFocus}
						onBlur={this.handleBlur}
						onChange={this.handleValueChange}
						name={props.name}
						type={type}
						value={this.state.value || ''}
					/>

					<div className="dd-country-flags" onClick={this.showDropDown}>
						<div className="dd-country-flags--list">
							<div
								className="dd-country-flags--current-flag"
								style={{
									backgroundImage: `url(https://www.countryflags.io/${this.state.currentCountry.iso2}/flat/64.png)`,
								}}></div>
							<div className="dd-country-flags--toggle"></div>
							<div className="dd-country-flags--details clean-scrollbars" aria-hidden={this.state.countryChoicesVisible}>
								{telephoneCountryList.map((country, key) => (
									<div
										key={key}
										className="dd-country-flags--item"
										onClick={(e) => {
											this.handleCountryChange(country);
										}}>
										<div
											key={key}
											className="dd-country-flags--icon"
											style={{
												background: `url(https://www.countryflags.io/${country.iso2}/flat/64.png) top center no-repeat`,
												backgroundSize: 'contain',
											}}></div>
										<div className="dd-country-flags--name">{country.display}</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</FormElementWrapper>
		);
	}
}

TelephoneInput.propTypes = {
	onCountry: PropTypes.func,
	required: PropTypes.bool,
	hidden: PropTypes.bool,
	hideLabel: PropTypes.bool,
	lockLabel: PropTypes.bool,
	label: PropTypes.string,
	tooltip: PropTypes.string,
	optionalLabel: PropTypes.string,
	className: PropTypes.string,
	showError: PropTypes.any,
	errorMessage: PropTypes.string,
	name: PropTypes.string.isRequired,
	type: PropTypes.string,
	value: PropTypes.any,
	getErrorMessage: PropTypes.func,
	onChange: PropTypes.func,
	onFocus: PropTypes.func,
	onBlur: PropTypes.func,
	getInputElement: PropTypes.func,
};

export default withFormsy(TelephoneInput);
